<ng-container>
  <div class="content85percent mt-3">
    <h1>Support: Manage Users</h1>
    <p>Use the tab to switch between managing client accounts, system accounts, and signing agent designations. Add users or use the search function to find specific users. Once located, you have the ability to manage them. Note: You are unable to edit your own account roles.</p>

    <app-tab-container
    (tabChange)="onTabChange($event)"></app-tab-container>

    @if (activeTab === 'system') {
      <div class="mb-3">
        <small class="text-muted">
          <strong>Role Descriptions: </strong>
          <em>Clear Sign Auditor</em> is a read-only role with access to view orders and the Orders Report.
          <em>Clear Sign Support</em> has full access to create, edit, and delete orders and users throughout the portal.
        </small>
      </div>
      <div class="width75">
        <button type="button"
          class="btn-primary float-end"
          (click)="openAddSystemUserModal()">
          + Add System User
        </button>
      </div>
    }

    @if (activeTab === 'designation') {
      <div class="mb-3">
        <small class="text-muted">
          <strong>Designation Descriptions: </strong>
          <em>Team Signing Agent</em> and <em>Preferred Agent</em> are additional descriptors on an account that already holds the Signing Agent role.
          An agent holds one of these or neither - never both, so changing a designation replaces the existing one.
        </small>
      </div>
      <div class="width75">
        <button type="button"
          class="btn-primary float-end"
          (click)="openAddDesignationModal()">
          + Add Designation
        </button>
      </div>
    }

    <app-user-filter [activeTab]="activeTab"
      [userList]="activeUserList"
    (filteredUserList)="onFilteredUserList($event)"></app-user-filter>
    <app-user-table-display [activeTab]="activeTab"
      [userList]="filteredUserList"
    (systemAccountDeleted)="onSystemAccountDeleted()"></app-user-table-display>
    <app-signing-agent-designation-table-display [activeTab]="activeTab"
      [userList]="filteredUserList"
      [loadFailed]="designationLoadFailed"
    (designationsChanged)="onDesignationsChanged()"></app-signing-agent-designation-table-display>
    <app-client-user-table-display [activeTab]="activeTab"></app-client-user-table-display>
  </div>
</ng-container>
